import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import SelectItem from "../../../app/generic/selectItem";
import { loadProducts } from "../../../../modules/staticDataLoad";
import SelectItemWithLoad from "../../../app/generic/selectItemWithLoad";

export const formItemId = "productId";

const Product = ({
  form,
  czech,
  collis,
  products,
  onSetLoading,
  onSetProducts,
  formItemLayout,
  onAnyValueChange,
  getFieldDecorator,
  onSetSelectedProduct,
}) => {
  const intl = useIntl();

  const [loadError, setLoadError] = useState();
  const handleSetProducts = useCallback(
    (loadedProducts) => {
      onSetLoading(true);
      if (loadedProducts === undefined || loadedProducts === "e") {
        onSetProducts("e");
        setLoadError(
          intl.formatMessage({
            id: "consignment.product.loadError",
            defaultMessage: "Při načítání produktů nastala chyba.",
          })
        );
      } else if (loadedProducts.length === 0) {
        onSetProducts("e");
        setLoadError(
          intl.formatMessage({
            id: "calculator.noProducts",
            defaultMessage: "Nemáte žádné povolené produkty!",
          })
        );
      } else {
        onSetLoading(false);
        onSetProducts(loadedProducts);
      }
    },
    [intl, onSetProducts, onSetLoading]
  );

  const handleLoadData = useCallback(() => {
    loadProducts(handleSetProducts, false);
  }, [handleSetProducts]);

  const handleProductSelect = useCallback(
    (productId) => {
      const product = products.find((p) => p.id === productId);
      if (product) {
        onSetSelectedProduct(product);
        const wrappings = {};
        collis.map((c) => (wrappings[`wrappings[${c}]`] = 9));
        czech &&
          product &&
          product.domestic &&
          form.setFieldsValue({
            pickupCountryId: czech.id,
            deliveryCountryId: czech.id,
            ...wrappings,
          });
        onAnyValueChange();
      }
    },
    [form, czech, collis, products, onAnyValueChange, onSetSelectedProduct]
  );

  useEffect(() => {
    handleLoadData();
  }, [intl.locale, handleLoadData]);

  return (
    <SelectItemWithLoad
      skeleton
      options={products}
      errorMessage={loadError}
      onClick={handleLoadData}
    >
      <SelectItem
        allowClear
        label={intl.formatMessage({
          id: "consignment.product",
          defaultMessage: "Produkt",
        })}
        options={products}
        fieldName={formItemId}
        placeholder={intl.formatMessage({
          id: "consignment.product.choose",
          defaultMessage: "Vyberte produkt zásilky",
        })}
        onSelect={handleProductSelect}
        formItemLayout={formItemLayout}
        message={intl.formatMessage({
          id: "consignment.product.chooseProduct",
          defaultMessage: "Pro pokračování vyberte produkt.",
        })}
        getFieldDecorator={getFieldDecorator}
      />
    </SelectItemWithLoad>
  );
};

export default Product;
